export enum MenuItems {
    Login,
    Roles,
    ImportCSV,
    Users,
    DataManagement,
    RankingTestHarness,
    CandidateSearchVectorTests,
    HelixSearch,
    LLMSettings,
    Kit,
    JobScreeners,
}
